module.exports = __webpack_public_path__ + "static/media/top-area-img.168d3fff.png";